import type { Supplier } from "./types";

/** Fallback supplier directory mirroring the seeded database rows (synthetic demo data). */
export const SEED_SUPPLIERS: Supplier[] = [
  {
    id: "sup-aventine",
    name: "Aventine Electronics",
    tier: "Tier 1",
    category: "Electronic control modules & sensors",
    contactName: "Marta Kowalczyk",
    contactTitle: "Director, Customer Quality",
    email: "marta.kowalczyk@aventine-electronics.com",
    phone: "+1 (313) 555-0142",
    address: "1420 Innovation Parkway",
    city: "Auburn Hills, MI",
    country: "United States",
    qualityRating: 3.9,
    ppm: 142,
    sqeOwner: "D. Ferreira (SQE)",
    contractRef: "PA-2024-AVE-118",
    escalationContact: "Rui Alves, VP Quality — rui.alves@aventine-electronics.com",
  },
  {
    id: "sup-kestrel",
    name: "Kestrel Motion Components",
    tier: "Tier 1",
    category: "Driveline & motion hardware",
    contactName: "Andreas Weber",
    contactTitle: "Head of Warranty & Field Quality",
    email: "andreas.weber@kestrelmotion.de",
    phone: "+49 711 555 0288",
    address: "Industriestrasse 44",
    city: "Stuttgart",
    country: "Germany",
    qualityRating: 4.3,
    ppm: 86,
    sqeOwner: "L. Okafor (SQE)",
    contractRef: "PA-2023-KES-072",
    escalationContact: "Petra Lindqvist, Plant Director — petra.lindqvist@kestrelmotion.de",
  },
  {
    id: "sup-halden",
    name: "Halden Ride Systems",
    tier: "Tier 1",
    category: "Suspension & ride control",
    contactName: "Sophie Tremblay",
    contactTitle: "Customer Quality Manager",
    email: "sophie.tremblay@haldenride.ca",
    phone: "+1 (519) 555-0367",
    address: "88 Foundry Road",
    city: "Windsor, ON",
    country: "Canada",
    qualityRating: 3.6,
    ppm: 214,
    sqeOwner: "J. Marchetti (SQE)",
    contractRef: "PA-2024-HAL-045",
    escalationContact: "Grant McAllister, COO — grant.mcallister@haldenride.ca",
  },
  {
    id: "sup-northline",
    name: "Northline Thermal Systems",
    tier: "Tier 1",
    category: "HVAC & thermal management",
    contactName: "Hiroshi Tanaka",
    contactTitle: "Senior Manager, Quality Assurance",
    email: "hiroshi.tanaka@northlinethermal.co.jp",
    phone: "+81 52 555 0913",
    address: "3-12 Kariya Techno Park",
    city: "Nagoya",
    country: "Japan",
    qualityRating: 4.6,
    ppm: 41,
    sqeOwner: "S. Bhatia (SQE)",
    contractRef: "PA-2022-NTS-201",
    escalationContact: "Keiko Mori, Division GM — keiko.mori@northlinethermal.co.jp",
  },
  {
    id: "sup-corvale",
    name: "Corvale Interiors",
    tier: "Tier 2",
    category: "Interior trim & soft goods",
    contactName: "Elena Rossi",
    contactTitle: "Warranty Recovery Lead",
    email: "elena.rossi@corvaleinteriors.it",
    phone: "+39 011 555 0774",
    address: "Via Torino 220",
    city: "Turin",
    country: "Italy",
    qualityRating: 3.4,
    ppm: 268,
    sqeOwner: "A. Nakamura (SQE)",
    contractRef: "PA-2025-COR-009",
    escalationContact: "Marco Bianchi, Commercial Director — marco.bianchi@corvaleinteriors.it",
  },
];
